import {NavList} from "./Header";

export const voiceMenuComplete: NavList[] = [
    {
        name: 'management',
        label: 'Gestione',
        child: [
            {
                name: 'companies',
                label: 'Aziende',
            },
            {
                name: 'pharmacists',
                label: 'Farmacisti',
            },
            {
                name: 'employees',
                label: 'Dipendenti',
            },
            {
                name: 'models',
                label: 'Modelli',
            },
            {
                name: 'users',
                label: 'Utenti',
            },
            {
                name: 'closeDays',
                label: 'Giorni di chiusura',
            },
            {
                name: 'typologyHours',
                label: 'Tipologia ore',
            }
        ]
    },
    {
        name: 'hours',
        label: 'Ore',
        child: [
           /* {
                name: 'service-hours',
                label: 'Ore di servizio',
            },*/
            {
                name: 'employeesSituation',
                label: 'Situazione dipendenti',
            },
            {
                name: 'hoursMany',
                label: 'Monte ore',
            },
            {
                name: 'stats',
                label: 'Statistiche',
            },
            {
                name: 'prospect',
                label: 'Prospetto',
            },
        ]
    },
    {
        name: 'calendar',
        label: 'Calendario',
    }
]
